import { createFileRoute, redirect, useNavigate } from '@tanstack/react-router'
import {
  type InventoryReportSearch,
  inventoryReportSearchFrom,
} from '@/features/inventory-analysis/api'
import { StockValueReportScreen } from '@/features/inventory-analysis/stock-value-screen'
import { hasGrant } from '@/lib/me'

export const Route = createFileRoute('/_authenticated/inventory/reports/stock-value')({
  validateSearch: (search: Record<string, unknown>): InventoryReportSearch =>
    inventoryReportSearchFrom(search),
  beforeLoad: ({ context }) => {
    if (!hasGrant(context.queryClient, 'inventory_report.view'))
      throw redirect({ to: '/inventory' })
  },
  component: StockValueReportRoute,
})

function StockValueReportRoute() {
  const navigate = useNavigate()
  const search = Route.useSearch()

  return (
    <StockValueReportScreen
      search={search}
      onSearchChange={(next) =>
        void navigate({ to: '/inventory/reports/stock-value', search: next })
      }
    />
  )
}
